import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, NgFor } from '@angular/common';
import { UntypedFormGroup, Validators } from '@angular/forms';
import {
  AccordionContentComponent,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/drawer-content/accordion-content.component';
import {
  OpenQuoteRequestsItem,
} from '@sbd-account-portal/app/modules/dashboard/open-quote-requests-widget/quote-requests.types';
import { validateCreditCard } from '@sbd-doug-frontend/shared/lib/public-validators';

@Component({
  selector: 'sbd-account-portal-frontend-checkout-page',
  standalone: true,
  imports: [
    CommonModule,
    NgFor,
    AccordionContentComponent,
    AccordionContentComponent,
  ],
  templateUrl: './checkout-page.component.html',
})
export class CheckoutPageComponent {
  @Input() selectedQR: OpenQuoteRequestsItem | null = null;
  @Input() queuedQR: OpenQuoteRequestsItem[] = [];
  @Input() subtotal: number = 0;
  @Input() checkoutForm: UntypedFormGroup;

  @Output() moveBackEvent = new EventEmitter<void>();
  @Output() closeDrawerEvent = new EventEmitter<void>();
  @Output() updatedOpenQREvent = new EventEmitter<OpenQuoteRequestsItem>();

  moveBack() {
    this.moveBackEvent.emit();
  }

  closeDrawer() {
    this.closeDrawerEvent.emit();
  }

  updateSelectedQuoteOption(event: OpenQuoteRequestsItem) {
    this.updatedOpenQREvent.emit(event);
  }
}
